/* ============================================================
   BARK x Dunkin'® 2026 — progressive enhancement
   - marks .dunkin roots with .dk-js so reveal styles apply
   - scroll-triggered reveals via IntersectionObserver
   - count-up numbers on scroll into view
   - confetti/sprinkle burst on Add to Cart clicks
   Respects prefers-reduced-motion. No inline scripts.
   ============================================================ */
(function () {
  "use strict";

  // Sections render independently, so this asset may be included more than
  // once. Initialise only once per page.
  if (window.__dunkinInit) return;
  window.__dunkinInit = true;

  function init() {
  var roots = Array.prototype.slice.call(document.querySelectorAll(".dunkin"));
  if (!roots.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  roots.forEach(function (root) {
    root.classList.add("dk-js");
  });

  /* ---------- reveal on scroll ---------- */
  var revealEls = [];
  roots.forEach(function (root) {
    revealEls = revealEls.concat(
      Array.prototype.slice.call(root.querySelectorAll(".dk-reveal"))
    );
  });

  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) {
      el.classList.add("dk-in");
    });
  } else {
    var revealObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute("data-dk-delay") || "0", 10);
          setTimeout(function () {
            el.classList.add("dk-in");
          }, delay);
          obs.unobserve(el);
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
    );
    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---------- count-up ---------- */
  function formatNumber(value, opts) {
    var rounded = Math.round(value);
    var str = rounded.toLocaleString("en-US");
    return (opts.prefix || "") + str + (opts.suffix || "");
  }

  function animateCount(el) {
    var to = parseFloat(el.getAttribute("data-dk-count") || "0");
    var duration = parseInt(el.getAttribute("data-dk-duration") || "1600", 10);
    var prefix = el.getAttribute("data-dk-prefix") || "";
    var suffix = el.getAttribute("data-dk-suffix") || "";
    var opts = { prefix: prefix, suffix: suffix };

    if (reduceMotion) {
      el.textContent = formatNumber(to, opts);
      return;
    }

    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatNumber(to * eased, opts);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = formatNumber(to, opts);
      }
    }
    window.requestAnimationFrame(step);
  }

  var countEls = [];
  roots.forEach(function (root) {
    countEls = countEls.concat(
      Array.prototype.slice.call(root.querySelectorAll("[data-dk-count]"))
    );
  });

  if (!("IntersectionObserver" in window)) {
    countEls.forEach(animateCount);
  } else {
    var countObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    countEls.forEach(function (el) {
      countObserver.observe(el);
    });
  }

  /* ---------- confetti / sprinkle burst on Add to Cart ---------- */
  var SPRINKLE_COLORS = ["#ef6a00", "#c63663", "#f8f4f1", "#fff45f", "#00b1e0"];

  function burst(originEl) {
    if (reduceMotion) return;
    var host = originEl.closest(".btn-dunkin") || originEl;
    // ensure host can position the sprinkles
    var computed = window.getComputedStyle(host);
    if (computed.position === "static") host.style.position = "relative";

    var count = 14;
    for (var i = 0; i < count; i++) {
      var s = document.createElement("span");
      s.className = "dk-sprinkle";
      var angle = Math.random() * Math.PI * 2;
      var distance = 40 + Math.random() * 60;
      s.style.setProperty("--tx", Math.cos(angle) * distance + "px");
      s.style.setProperty("--ty", Math.sin(angle) * distance + "px");
      s.style.setProperty("--r", Math.random() * 540 - 270 + "deg");
      s.style.background = SPRINKLE_COLORS[i % SPRINKLE_COLORS.length];
      host.appendChild(s);
      (function (node) {
        setTimeout(function () {
          if (node && node.parentNode) node.parentNode.removeChild(node);
        }, 950);
      })(s);
    }
  }

  roots.forEach(function (root) {
    root.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-dk-confetti]");
      if (trigger && root.contains(trigger)) burst(trigger);
    });
  });
  } // init

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
